// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606251202/js/" + chunkId + "." + {"44":"dedfe22b","225":"6bade37f","481":"62ca1658","486":"5b65f5f0","770":"78cd90ca"}[chunkId] + ".0.3093949680013124.chunk.js";
};